// eslint-disable-next-line no-unused-vars
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { servicios, multicanalMascota } from "../properties";
import "./gnp-multicanal.css";
import { Id_Producto_Backend } from "../constants/constants";

const mapState = state => {
	return {
		loading: state.global.loading,
		nombre: state.global.nombre,
		multicanalGnp: state.multicanalGnp
	};
};

class MulticanalFlujos extends Component {

	generateIframe = () => {
		const jwtPortal = localStorage.getItem("refreshToken");
		let pathWithParams = `${servicios.multicanal.endPoint}/${this.props.numPoliza}/${this.props.flujo}/${jwtPortal}`;
		switch (this.props.flujo) {
			case Id_Producto_Backend.SINIESTRO.lebel:
				pathWithParams =  `${multicanalMascota.endPoint}multicanal/${this.props.numPoliza}/${Id_Producto_Backend.SINIESTRO.id}/${jwtPortal}`;
				break;
			case Id_Producto_Backend.SEGUIMIENTO.lebel:
					pathWithParams =  `${multicanalMascota.endPoint}multicanal/${this.props.numPoliza}/${Id_Producto_Backend.SEGUIMIENTO.id}/${jwtPortal}`;
					break;
			case Id_Producto_Backend.HISTORIAL.lebel:
				pathWithParams =  `${multicanalMascota.endPoint}multicanal/${this.props.numPoliza}/${Id_Producto_Backend.HISTORIAL.id}/${jwtPortal}`;
				break;
			default:
				break;
		}
		return `<iframe allow="geolocation *;" ref="iFrame" frameBorder="0" width="100%" class="frame-multicanal" src=${pathWithParams}></iframe>`;
	}

	iframe = () => {
		return {
			__html: this.generateIframe()
		}
	}

	render() {
	
		return (
			<div>
				<div dangerouslySetInnerHTML={ this.iframe() } />
			</div>
		);
	}
}

MulticanalFlujos.propTypes = {
	numPoliza: PropTypes.string,
	flujo: PropTypes.string,
};

export default connect(mapState)(MulticanalFlujos);


// WEBPACK FOOTER //
// ./src/gnp-multicanal/multicanalFlujos.cmpt.js